import { StaticDatePicker } from '@mui/x-date-pickers';
import { Box, Alert } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock';
import { setHours, setMinutes, isToday, addHours } from 'date-fns';

import { fIsWeekend, fIsPublicHoliday } from '../../utils/formatTime';

interface PreferredAssessmentDateProps {
	onChange: (date: Date) => void;
	initialDate: Date;
}

const PreferredAssessmentDate = ({ onChange, initialDate }: PreferredAssessmentDateProps) => {
	const onDateChange = (date: Date | null): void => {
		if (date && initialDate) {
			const newDate = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate(),
				initialDate.getHours(),
				initialDate.getMinutes(),
			);

			onChange(newDate);
		}
	};

	const onTimeChange = (time: Date | null): void => {
		if (time && initialDate) {
			const newTime = setMinutes(setHours(initialDate, time.getHours()), time.getMinutes());

			onChange(newTime);
		}
	};

	const disableDate = (date: Date): boolean => {
		return fIsWeekend(date) || fIsPublicHoliday(date);
	};

	let minTime: Date;

	if (initialDate && isToday(initialDate)) {
		const nowPlus4Hours = addHours(new Date(), 4);
		const earliest8AM = setHours(setMinutes(new Date(), 0), 8);
		minTime = nowPlus4Hours > earliest8AM ? nowPlus4Hours : earliest8AM;
	} else {
		minTime = setHours(setMinutes(new Date(), 0), 8);
	}

	return (
		<Box>
			<Alert severity="info">
				We'll try our best to schedule your preferred time. Your appointment is NOT confirmed until you receive a
				booking email from us. Appointments are typically completed within 3 business days.
			</Alert>
			<Grid container justifyContent={'center'}>
				<Grid size={{ md: 6 }}>
					<StaticDatePicker
						value={initialDate}
						onChange={onDateChange}
						shouldDisableDate={disableDate}
						disablePast
						slots={{ actionBar: () => null }}
					/>
				</Grid>
				<Grid size={{ md: 6 }}>
					<DigitalClock
						skipDisabled
						maxTime={setMinutes(setHours(new Date(), 16), 30)}
						minTime={minTime}
						sx={{ mt: 12 }}
						onChange={onTimeChange}
						value={initialDate}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

export default PreferredAssessmentDate;
